import React from 'react'
import { OptimizelyClientSideExperiments, useOptimizelyExperiment } from 'lib/optimizely'
import LineGiftIcon from 'components/Luxkit/Icons/line/LineGiftIcon'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import LineStarIcon from 'components/Luxkit/Icons/line/LineStarIcon'
import LineTagAltIcon from 'components/Luxkit/Icons/line/LineTagAltIcon'
import LineUsersMultiIcon from 'components/Luxkit/Icons/line/LineUsersMultiIcon'
import { ColouredFacebookRoundIcon } from 'components/Account/AccountAccess/common'
import GoogleIcon from 'components/Luxkit/Icons/custom/GoogleIcon'

type LoginStartModalVariantContent = {
  [variant: string]: LoginStartModalVariantContentDetails
}

export type LoginStartModalVariantContentDetails = {
  header: string;
  body: {
    Icon?: JSX.Element;
    text: string;
  }[];
  socialMediaLogin: {
    customIcons?: { [key: string]: JSX.Element;};
    inline?: boolean;
    position: 'below-email-input' | 'above-email-input';
    text?: { hideText?: boolean; customText?: {[key: string]: string; }};
    squareIcons?: boolean,
  };
  trustIndicators?: {
    hideFacebook: boolean;
  }
}

const loginStartTestVariantContent: LoginStartModalVariantContent = {
  variant1: {
    header: 'Discover a better way to travel with Luxury Escapes',
    body: [
      { Icon: <LineGiftIcon />, text: 'Unlock thousands of exclusive offers' },
      { Icon: <LineStarIcon />, text: 'Save up to 75% off and enjoy VIP inclusions' },
      { Icon: <LinePhoneIcon />, text: 'Our local team are available 24 hours, 7 days' },
    ],
    socialMediaLogin: {
      customIcons: { facebook: <ColouredFacebookRoundIcon />, google: <GoogleIcon /> },
      inline: true,
      position: 'below-email-input',
      text: { hideText: true },
      squareIcons: true,
    },
  },
  variant2: {
    header: 'Members save up to 75% off',
    body: [
      { Icon: <LineGiftIcon />, text: 'Unlock thousands of exclusive offers' },
      { Icon: <LineStarIcon />, text: 'Over a million trips taken every year' },
      { Icon: <LinePhoneIcon />, text: 'Our local team are available 24 hours, 7 days' },
    ],
    socialMediaLogin: {
      inline: true,
      position: 'below-email-input',
      text: { customText: { google: 'Google', apple: 'Apple', facebook: 'Facebook' } },
    },
  },
  variant3: {
    header: "Unlock exclusive deals you won't find anywhere else",
    body: [
      { text: 'Join more than 6 million members and experience travel differently with Luxury Escapes' },
    ],
    socialMediaLogin: {
      position: 'above-email-input',
    },
    trustIndicators: {
      hideFacebook: true,
    },
  },
  variant4: {
    header: 'Sign up and save up to 75%',
    body: [
      { Icon: <LineTagAltIcon />, text: 'Best in-market discounts in exclusive Luxury Hotels' },
      { Icon: <LineGiftIcon />, text: "Thousands of offers that you won't find elsewhere" },
      { Icon: <LineUsersMultiIcon />, text: 'Over 1 million members already travel with us. Join now!' },
    ],
    socialMediaLogin: {
      position: 'below-email-input',
    },
  },
}

export function useLoginStartModalExperiment(activateExperiment: boolean) {
  const loginStartModalTestVariant = useOptimizelyExperiment(OptimizelyClientSideExperiments.loginStartTest, activateExperiment)
  const getLoginStartModalTestVariantContent = loginStartModalTestVariant ? loginStartTestVariantContent[`variant${loginStartModalTestVariant}`] : undefined
  return [getLoginStartModalTestVariantContent]
}
